import React, { useState } from 'react';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';
import ExploreIcon from '@mui/icons-material/Explore';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

import QueryForm from './QueryForm';
import './PageTabs.css';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  boxShadow: 'none',
}));

const VIDEOS = [
  { title: 'See how your favourite Ghee is prepared?', src: 'https://www.youtube.com/embed/yRUUSoxHHs0' },
  { title: 'Ananda Business Associates Awards', src: 'https://www.youtube.com/embed/XXDx2LxF9C8' },
  { title: 'Besan ke laddu with Ananda Ghee', src: 'https://www.youtube.com/embed/Gqnc7TtmtE4' },
];

const LEARN_COPY =
  'Ananda Ghee is an ethnic product made by our dairies with decades of experience. Our Ghee is a rich source of vitamins A and D, antioxidants, Omega 3 and CLA, essential for vision, body growth, bone metabolism and immune system.';

/**
 * Secondary/contextual content for a verification page — brand videos,
 * product info, and the contact/query form — grouped into tabs instead of
 * three long stacked sections, since these are related content categories
 * a visitor dips into after the primary verification result above.
 */
function PageTabs({ code, buyHref, onBuyClick, showConnect = true }) {
  const [tab, setTab] = useState(0);

  return (
    <Card className="page-tabs-card">
      <div className="page-tabs-toolbar">
        <Tabs value={tab} onChange={(e, v) => setTab(v)} variant="scrollable" scrollButtons="auto">
          <Tab icon={<ExploreIcon fontSize="small" />} iconPosition="start" label="Discover" />
          <Tab icon={<MenuBookIcon fontSize="small" />} iconPosition="start" label="Learn" />
          {showConnect && <Tab icon={<ChatBubbleOutlineIcon fontSize="small" />} iconPosition="start" label="Connect" />}
        </Tabs>
        {onBuyClick ? (
          <Button className="page-tabs-buy" variant="contained" startIcon={<ShoppingCartIcon />} onClick={onBuyClick}>
            Buy Now
          </Button>
        ) : (
          <Button
            className="page-tabs-buy"
            variant="contained"
            startIcon={<ShoppingCartIcon />}
            component="a"
            href={buyHref}
            target="_blank"
            rel="noreferrer"
          >
            Buy Now
          </Button>
        )}
      </div>

      {tab === 0 && (
        <div className="page-tabs-panel">
          <Grid container spacing={2}>
            {VIDEOS.map((v) => (
              <Grid item lg={3} sm={6} xs={12} key={v.src}>
                <Item>
                  <Card className="discover-media-card">
                    <p className="video-title">{v.title}</p>
                    <iframe
                      className="discover-media"
                      src={v.src}
                      title={v.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </Card>
                </Item>
              </Grid>
            ))}
            <Grid item lg={3} sm={6} xs={12}>
              <Item>
                <Card className="discover-media-card">
                  <p className="video-title">Our other products</p>
                  <a href="https://ananda.in/main-category/" target="_blank" rel="noreferrer">
                    <img
                      className="discover-media"
                      src={process.env.PUBLIC_URL + '/images/ananda-products.webp'}
                      alt="Ananda products"
                    />
                  </a>
                </Card>
              </Item>
            </Grid>
          </Grid>
        </div>
      )}

      {tab === 1 && (
        <div className="page-tabs-panel page-tabs-learn">
          <p className="video-title">{LEARN_COPY}</p>
        </div>
      )}

      {showConnect && tab === 2 && (
        <div className="page-tabs-panel">
          <QueryForm code={code} />
        </div>
      )}
    </Card>
  );
}

export default PageTabs;
